import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BsModalService} from "ngx-bootstrap/modal";
import {ModalDeleteComponent} from "../modals/modal-delete/modal-delete.component";
import {DeleteService} from "../../services/delete.service";

type TEntity = '' | 'action' | 'moderator' | 'product' | 'project' | 'user' |
  'store' | 'store collection' | 'store group' | 'store key' | 'store version' | 'custom data';

@Component({
  selector: 'btn-delete',
  templateUrl: './btn-delete.component.html'
})
export class BtnDeleteComponent implements OnInit {

  @Input() type: TEntity = '';
  @Input() name: string;
  @Input() disabled: boolean;

  @Output() delete: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancel: EventEmitter<any> = new EventEmitter<any>();

  constructor(private deleteService: DeleteService) { }

  ngOnInit(): void {
  }

  confirm() {
    const response = {type: this.type, name: this.name};
    this.deleteService.confirm(this.type, this.name).then(
      () => {
        this.delete.emit(response);
      },
      () => {
        this.cancel.emit(response);
      }
    );
  }

}
